import useReportMetadata from '@/modules/report/hooks/useReportMetadata';

import {
  JourneyBuilderFragment,
  useGetJourneyBuilderQuery,
} from '../../../JourneyBuilder/graphql/queries/generated/getJourneyBuilder';

interface Params {
  journeyId: string;
}

const useJourneyData = ({ journeyId }: Params) => {
  const [{ data, error, fetching }, refetch] = useGetJourneyBuilderQuery({
    variables: { input: { id: journeyId } },
    pause: !journeyId,
  });
  const { isLoading, reportAttributes, error: errorMetadata } = useReportMetadata();

  const journey = data?.journey?.journey as JourneyBuilderFragment;

  return {
    fetching: fetching || isLoading,
    error: error || errorMetadata,
    journey,
    reportAttributes,
  };
};

export default useJourneyData;
